import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, Button, Row, Input } from 'antd';
import * as HAR from 'har-format';

interface DumpModalProps {
  visible: boolean;
  onCancel: () => void;
  har?: HAR.Har;
}

const DumpModal = ({ visible, onCancel, har }: DumpModalProps) => {
  const { t } = useTranslation('common');
  const [filename, setFilename] = useState('');

  const onDownload = () => {
    const dataStr = 'data:text/json;charset=utf-8,' + encodeURIComponent(JSON.stringify(har, null, 2));
    const downloadAnchorNode = document.createElement('a');
    downloadAnchorNode.setAttribute('href', dataStr);
    downloadAnchorNode.setAttribute('download', `${filename || 'new'}.har`);
    document.body.appendChild(downloadAnchorNode); // required for firefox
    downloadAnchorNode.click();
    downloadAnchorNode.remove();
  };

  return (
    <Modal title="Dump HAR file" open={visible} onCancel={onCancel} footer={[]}>
      <>
        <Row>
          {t('Please confirm the filename to download to:')}
          <Input
            type="text"
            autoComplete="off"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setFilename(e.target.value);
            }}
          />
        </Row>
        <Row style={{ width: '100%', marginTop: '16px' }}>
          <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
            <Button
              key="close"
              style={{ marginRight: '8px' }}
              onClick={() => {
                onCancel();
              }}
              data-testid="close-button"
            >
              {t('Close')}
            </Button>
            <Button key="download-har" type="primary" data-testid="download-har-button" onClick={onDownload}>
              {t('Download HAR')}
            </Button>
          </div>
        </Row>
      </>
    </Modal>
  );
};

export default DumpModal;
